import { Accordion, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

function DescriptionAccordion({ title, children }) {
  return (
    <Accordion>
      <Accordion.Toggle
        as={Button}
        variant="link"
        eventKey="0"
        style={{ padding: '10px 0', margin: '10px 2px', border: 0 }}
      >
        {title}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="0">
        <div>{children}</div>
      </Accordion.Collapse>
    </Accordion>
  );
}

DescriptionAccordion.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
};

export default DescriptionAccordion;
